export default from './SMSTemplates';



// WEBPACK FOOTER //
// ./src/containers/SMSTemplates/index.js